module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <cn-mail modal=true subject=standard_performance_invite_email_title message=standard_performance_invite_email_content signature=standard_invite_email_signature on-reset=reset on-submit=submit first-name={{me.first_name}} last-name={{me.last_name}} title=\"{{'invite.email.resend' | translate}}\"></cn-mail> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-invite/performance-review-invite/performance-review-invite.modal.email.html
 ** module id = 253
 ** module chunks = 0
 **/